import axios from 'axios';
import { getField, updateField } from 'vuex-map-fields';

export default {
  namespaced: true,
  state: {
    myInvites: {
      customers: [],
      paginate: 0,
      total: 0,
    },
    actionInfo: {},
    loadingModal: true,
    error: null,
  },

  getters: {
    getField,
  },

  mutations: {
    updateField,
    SET_INVITES(state, payload) {
      state.myInvites = payload;
    },
    SET_ACTION_INFO(state, payload) {
      state.actionInfo = payload;
    },
  },

  actions: {
    async setInvites({ commit }, obj) {
      const { data } = await axios.get(
        `${process.env.API_ROOT}/invites/${obj.companyId}`,
        {
          headers: {
            'x-access-token': obj.token,
          },
          params: {
            ...obj.queryParams,
          },
        },
      );

      const invites = {
        ...data,
        paginate: Math.ceil(data.total / 10),
      };

      commit('SET_INVITES', invites);
    },

    async setActionInfo({ commit }, token) {
      const { data } = await axios.put(
        `${process.env.API_ROOT}/research-info`,
        { token },
      );

      commit('SET_ACTION_INFO', data);
    },

    async resendInvites({ commit }, obj) {
      await axios.put(
        `${process.env.API_ROOT}/resend/${obj.companyId}`,
        {
          ...obj.data,
        },
        {
          headers: {
            'x-access-token': obj.token,
          },
        },
      );
    },

    async wppInvites({ commit }, obj) {
      const ret = await axios.post(
        `${process.env.API_ROOT}/wpp-invites/${obj.companyId}`,
        {
          ...obj.data,
        },
        {
          headers: {
            'x-access-token': obj.token,
          },
        },
      );
      return ret;
    },

    async updateToken({ commit }, obj) {
      await axios.put(
        `${process.env.API_ROOT}/invite/refresh/${obj.companyId}`,
        {
          ...obj.data,
        },
        {
          headers: {
            'x-access-token': obj.token,
          },
        },
      );
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/invites/index.js